import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-R733Q1T9BC';

const Analytics: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const gtag = (window as any).gtag as ((...args: any[]) => void) | undefined;
    if (typeof gtag === 'function') {
      gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
